<template>
  <div v-if="!this.loading">

    <h3 class="mt-5">{{this.datasetData.data.instance[0].showroom_name}}</h3>

    <p>{{this.datasetData.data.instance[0].showroom_header}}</p>

    <p>Statistics last updated: <i>{{(new Date(this.datasetData.data.instance[0].last_updated)).toDateString()}}</i></p>

    <div class="mt-5" v-for="tableDefinition in this.datasetData.data.tables" v-bind:key="tableDefinition.table_name">

      <h5> Table Name: <i> {{ tableDefinition.table_name }} </i> </h5>

      <p>{{ tableDefinition.table_header }}</p>

      <table class="table">
        <thead class="table-header">
          <tr>
            <th style="width: 15%">Field name</th>
            <th>Description</th>
            <th style="width: 12%">Type</th>
            <th style="width: 12%"># Rows</th>
            <th style="width: 12%">% Complete</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="tableRow in datasetData.data.content[tableDefinition.table_code]" v-bind:key="tableRow.field_name">
            <td>{{ tableRow.field_name }}</td>
            <td>{{ tableRow.field_desc }}</td>
            <td>{{ tableRow.field_type }}</td>
            <td>{{ tableRow.field_row_num }}</td>
            <td>{{ tableRow.field_row_complete_percent }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <p class="footer mt-5">{{this.datasetData.data.instance[0].showroom_footer}}</p>

  </div>
</template>

<script>
import Data from '@/components/Data'
export default {
  name: 'Introduction',
  data () {
    return {
      dataset: this.$route.params.dataset,
      datasetData: {},
      loading: true
    }
  },
  mounted () {
    Data.get(this.dataset)
      .then(result => {
        this.datasetData = result
      }, error => {
        console.error('error while calling dataset data:' + this.dataset)
        console.error(error)
        return this.$router.push('/404')
      })
      .finally(() => {
        this.loading = false
      })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table-header, .footer{
  background-color: #F4EFEA;
}
</style>



// WEBPACK FOOTER //
// src/components/Introduction.vue